import {useState} from 'react';
import {Button, Card, Row, Col, Input, message} from 'antd';
import {UserSelectWidget} from "./UserSelectWidget";
import {insertTask, insertTaskFollower} from "../../api/Api";
import {TASK_DESCRIPTION_MAX_LENGTH} from "../../api/Constants";
import {DatePickerWidget} from "../widget/DatePickerWidget";
import {FollowerSelectWidget} from "./FollowerSelectWidget";

const {TextArea} = Input;

export const NewTask = ({refresh, onRefresh, onApiFail, onNewTask, props}) => {
    const [title, setTitle] = useState(undefined);
    const [description, setDescription] = useState(undefined);
    const [dueDate, setDueDate] = useState(undefined);
    const [assignTo, setAssignTo] = useState(undefined);
    const [followers, setFollowers] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [pickerActive, setPickerActive] = useState(false);

    // displayDate is important, we are working around a UTC to local timezone change
    // we need to feed DatePickerWidget a local time so that it works as expected, otherwise date is off by 1
    const [displayDate, setDisplayDate] = useState(undefined);
;
    const clearForm = () => {
        setTitle(undefined);
        setDescription(undefined);
        setAssignTo(undefined);
        setDueDate(undefined);
        setAssignTo(undefined);
        setFollowers([]);
    }

    const onTitleChange = (e) => {
        setTitle(e.target.value);
    }

    const onDescriptionChange = (e) => {
        setDescription(e.target.value);
    }

    const onDueDateChange = (dateString, dateJs) => {
        // dueDate will be fed to the backend and retained correctly as a local date/time via mysql
        setDueDate(dateString);

        const dateJsString = dateJs.toString();

        // we will set displayDate to a local time for DatePickerWidget
        setDisplayDate(dateJsString);
    }

    const setAssignment = (val) => {
        setAssignTo(val);
    }

    const setUserPickerActive = (val) => {
        setPickerActive(val);
    }

    const addFollower = (follower) => {
        let followerExists = false;
        followers.forEach(f => {
            if (f.id === follower.id) {
                followerExists = true;
            }
        });
        if (!followerExists) {
            const nextFollowers = [...followers];
            nextFollowers.push(follower);
            setFollowers(nextFollowers);
        }
    }

    const removeFollower = (follower) => {
        const nextFollowers = [];
        followers.forEach(f => {
            if (f.id !== follower.id) {
                nextFollowers.push(f);
            }
        });
        setFollowers(nextFollowers);
    }

    const saveTask = () => {
        insertTask(title, description, (assignTo ? assignTo.id : undefined), dueDate).then(r => {
            if (onNewTask) {
                onNewTask({id: r.id, title, description});
            }
            if (followers.length > 0) {
                return insertTaskFollower(r.id, followers);
            } else {
                return Promise.resolve({});
            }
        }).then(r => {
            console.log(`success`);
            messageApi.open({
                type: "success",
                content: "Task Created"
            });
            clearForm();
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
            messageApi.open({
                type: "error",
                content: "Failed to Create Task"
            })
        })
    }

    const rowStyle = {
        marginTop: '10px',
        marginBottom: '20px'
    }

    const dueDateInvalid = (dueDate === null) || (dueDate === undefined);
    const titleInvalid = (title === null) || (title === undefined) || title === "";
    const saveDisabled = dueDateInvalid || titleInvalid || pickerActive;

    return <div style={{textAlign: 'left'}}>
        {contextHolder}
        <Card title={"New Task"} >
            <Row style={rowStyle}>
            <TextArea value={title} placeholder={'title'} showCount rows={1} maxLength={256} onChange={onTitleChange} />
            </Row>
            <Row style={rowStyle}>
            <TextArea value={description} placeholder={`description`} showCount rows={10} maxLength={TASK_DESCRIPTION_MAX_LENGTH} onChange={onDescriptionChange}/>
            </Row>
            <Row style={rowStyle}>
                <DatePickerWidget placeholder={"Assign Due Date"} onChange={onDueDateChange} date={displayDate} />
            </Row>
            <Row style={rowStyle}>
                <UserSelectWidget user={assignTo} altText={`assign to`} onApiFail={onApiFail} setUser={setAssignment} setComponentActive={setUserPickerActive}/>
            </Row>
            <Row>
                <Col span={2}>
                    <b>Followers:</b>
                </Col>
                <Col>
                    <FollowerSelectWidget onRefresh={onRefresh} refresh={refresh} onApiFail={onApiFail}
                          followers={followers} addFollower={addFollower} removeFollower={removeFollower} />
                </Col>
            </Row>
            <Row style={rowStyle}>
                <Button onClick={saveTask} disabled={saveDisabled}>Save Task</Button>
            </Row>
        </Card>
    </div>
}